import { Checkbox } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { useViewportDevice } from '@/hooks';
import { Tooltip } from '@/module/auth/sign-up/components/Tooltip';
import { cn } from '@/utils';

/**
 * SaveForNextQuizCheckbox - "다음에도 사용" 체크박스
 *
 * BuildInfoContext와 BuildFormContext에 의존하지 않는 독립적인 컴포넌트입니다.
 * 모달 내부에서도 사용 가능합니다.
 *
 * @param checked - 체크박스 선택 상태
 * @param onChange - 체크박스 값 변경 핸들러
 * @param className - 추가 스타일 클래스
 */
export const SaveForNextQuizCheckbox = ({
  checked,
  onChange,
  className
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const {
    isMobile
  } = useViewportDevice();
  const checkboxElement = <label htmlFor="save-for-next-quiz" className={cn('flex w-fit shrink cursor-pointer items-center justify-end gap-xs bg-white', className)} onClick={e => {
    e.stopPropagation();
  }}>
      <Checkbox id="save-for-next-quiz" checked={checked} onCheckedChange={onChange} />
      <span className="min-w-fit text-body-lg-semibold">
        {t('build:schoolInfo.nextUsed')}
      </span>
    </label>;

  // 모바일에서는 체크박스만 표시
  if (isMobile) {
    return checkboxElement;
  }

  // 데스크톱에서는 툴팁 포함
  return <Tooltip side="top" align="center" className="bg-white text-default" arrow={{
    fill: '#FFF'
  }} trigger={checkboxElement} content={t('build:schoolInfo.savedGuide')} data-sentry-element="Tooltip" data-sentry-component="SaveForNextQuizCheckbox" data-sentry-source-file="SaveForNextQuizCheckbox.tsx" />;
};